<script>

import AccountTradesTable from "@/components/Dashboard/Views/Pages/StrategyInfoV2/AccountTradesTable.vue";

export default {
  name: 'TradesOnMaster',
  components: {
    AccountTradesTable
  },
  computed: {},
  data() {
    return {
      inprogress: true,
      pageTitle: this.$t('tradesonstrategytxt'),
      account: '0',
    }
  },
  methods: {
    prevPage() {
      window.history.back();
    },
    async loadStrategy() {
      try {
        let sid = JSON.parse(localStorage.getItem('_tmp-sid'))

        let success = resp => {
          this.account = resp.data[0]
          this.inprogress = false
        }
        let fail = resp => {
          this.account = '0'
          this.inprogress = false
        }

        this.$getStrategyReference(sid).then(success, fail)

      } catch {
        this.failredirect();
      }
    },
    failredirect: () => {
      this.inprogress = false;
    },
  },
  async mounted(){
    await this.loadStrategy();
  }
}
</script>

<template>
  <module
    ref="module"
    titleIcon="fa fa-th-large"
    :title="pageTitle"
    :use-default-list="false"
  >
    <div slot="toolbar-global">
      <p-button type="default" v-on:click="prevPage()">
        <i slot="label" class="nc-icon nc-minimal-left"></i>
        {{ $t('back') }}
      </p-button>
    </div>
    <div slot="global">
      <div v-if="inprogress" class="text-center text-black my-5">
        <h4>{{ $t('loadingtxt') }} {{ $t('tradesonstrategytxt') }}. {{ $t('pleasewait') }}</h4>
        <i class="fa fa-spinner fa-spin fa-fw" style="font-size: 60px;"></i>
      </div>
      <div v-else>
        <account-trades-table type="open" :account="account" />
        <account-trades-table type="history" :account="account" />
      </div>
    </div>
  </module>
</template>

<style scoped>

</style>
